"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function removeDomain(url) {
    return url.replace(/^[a-z]{4,5}\:\/{2}[a-z0-9\.]{1,}[\:]{0,1}[0-9]{0,4}(.*)/, '$1');
}
exports.default = removeDomain;
